var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslateIconTrue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.279 3.2C9.896 5.273 7.443 7.894 6.336 9.206l-2.704-2.12-1.196.963 4.668 4.751c.8-2.058 3.349-6.08 6.458-8.94L13.28 3.2z",
    fill: "#5FC475"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjI3ODcgMy4xOTkyMkM5Ljg5NjMxIDUuMjc0MyA3LjQ0MjkzIDcuODk0NTggNi4zMzU4NSA5LjIwNzVMMy42MzIxMyA3LjA4NzkxTDIuNDM2MDQgOC4wNTAzNUw3LjEwMzU4IDEyLjgwMTNDNy45MDQ2OCAxMC43NDI5IDEwLjQ1MjYgNi43MjA3NCAxMy41NjI1IDMuODYxMjRMMTMuMjc4NyAzLjE5OTIyWiIgZmlsbD0iIzVGQzQ3NSIvPgo8L3N2Zz4K";
export { SvgTranslateIconTrue as ReactComponent };